(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edo-brand-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = (video) => {
      video.muted = true;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    };

    const init = () => {
      document.querySelectorAll('.edo-story__video[autoplay]').forEach((video) => {
        if (video.readyState >= 2) {
          start(video);
        } else {
          video.addEventListener('loadeddata', () => start(video), { once: true });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edo-launch-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cards = document.querySelectorAll('.edo-launch-card');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    if (!reduced.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14 });

      cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * 90}ms`;
        observer.observe(card);
      });
    } else {
      cards.forEach((card) => card.classList.add('is-visible'));
    }

    if (!pointer.matches || reduced.matches) return;

    cards.forEach((card) => {
      const media = card.querySelector('.edo-launch-card__media');
      if (!media) return;

      media.addEventListener('pointermove', (event) => {
        const rect = media.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;

        media.style.setProperty('--edo-card-x', `${x * 100}%`);
        media.style.setProperty('--edo-card-y', `${y * 100}%`);
        media.style.setProperty('--edo-card-rx', `${(0.5 - y) * 7}deg`);
        media.style.setProperty('--edo-card-ry', `${(x - 0.5) * 7}deg`);
      });

      media.addEventListener('pointerleave', () => {
        media.style.removeProperty('--edo-card-x');
        media.style.removeProperty('--edo-card-y');
        media.style.removeProperty('--edo-card-rx');
        media.style.removeProperty('--edo-card-ry');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edo-light-study"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = (video) => {
      if (video.dataset.loaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.dataset.loaded = 'true';
      video.load();
    };

    const start = (video) => {
      video.muted = true;
      load(video);

      if (video.readyState >= 2) {
        const playback = video.play();
        if (playback) playback.catch(() => {});
        return;
      }

      video.addEventListener(
        'loadeddata',
        () => {
          const playback = video.play();
          if (playback) playback.catch(() => {});
        },
        { once: true }
      );
    };

    const init = () => {
      const videos = document.querySelectorAll('.edo-light-study video[data-lazy-video]');

      if (!('IntersectionObserver' in window)) {
        videos.forEach(start);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              start(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { rootMargin: '300px 0px', threshold: 0.01 }
      );

      videos.forEach((video) => observer.observe(video));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edo-masters-eye-teaser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => document.querySelectorAll('.lc-masters-eye-teaser video').forEach((video) => {
      video.muted = true;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    });
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init, { once: true })
      : init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edo-theme-styles"]) return;
  try {
    
  (() => {
    const init = () => {
      const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const revealTargets = document.querySelectorAll(
        '.edo-trust, .edo-launch, .lovecove-motion, .edo-story, .edo-craft, .edo-collections, .edo-gift, .edo-newsletter, .edo-pattern, .edo-light-study, .related-products'
      );

      if ('IntersectionObserver' in window) {
        document.documentElement.classList.add('edo-motion-ready');
        revealTargets.forEach((target) => target.classList.add('edo-scroll-reveal'));

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('edo-scroll-reveal--visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
        );

        revealTargets.forEach((target) => observer.observe(target));
      }

      if (!pointer.matches) return;

      let frame = 0;
      let pending;

      const update = () => {
        frame = 0;
        if (!pending) return;

        const { card, x, y, width, height } = pending;
        const lightX = (x / width) * 100;
        const lightY = (y / height) * 100;
        const tiltX = ((0.5 - y / height) * 2.4).toFixed(2);
        const tiltY = (((x / width) - 0.5) * 2.4).toFixed(2);

        card.style.setProperty('--edo-light-x', `${lightX}%`);
        card.style.setProperty('--edo-light-y', `${lightY}%`);
        card.style.setProperty('--edo-tilt-x', `${tiltX}deg`);
        card.style.setProperty('--edo-tilt-y', `${tiltY}deg`);
      };

      document.addEventListener('pointermove', (event) => {
        const card = event.target.closest('.featured-collection .card-wrapper, .related-products .card-wrapper');
        if (!card) return;

        const rect = card.getBoundingClientRect();
        pending = {
          card,
          x: event.clientX - rect.left,
          y: event.clientY - rect.top,
          width: rect.width,
          height: rect.height
        };

        if (!frame) frame = requestAnimationFrame(update);
      });

      document.addEventListener('pointerout', (event) => {
        const card = event.target.closest('.featured-collection .card-wrapper, .related-products .card-wrapper');
        if (!card || card.contains(event.relatedTarget)) return;

        card.style.removeProperty('--edo-light-x');
        card.style.removeProperty('--edo-light-y');
        card.style.removeProperty('--edo-tilt-x');
        card.style.removeProperty('--edo-tilt-y');
      });

    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovecove-craft-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => document.querySelectorAll('.lovecove-craft-intro video').forEach((video) => {
      video.muted = true;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    });
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init, { once: true })
      : init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovecove-craft-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => document.querySelectorAll('.lovecove-craft-portal video').forEach((video) => {
      video.muted = true;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    });
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init, { once: true })
      : init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovecove-motion-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('.lovecove-motion').forEach((section) => {
        if (section.dataset.motionReady === 'true') return;

        const video = section.querySelector('.lovecove-motion__video');
        const toggle = section.querySelector('.lovecove-motion__toggle');
        const label = section.querySelector('.lovecove-motion__toggle-label');
        if (!video || !toggle || !label) return;

        section.dataset.motionReady = 'true';

        const update = () => {
          const paused = video.paused;
          toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          label.textContent = paused ? 'Play film' : 'Pause film';
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.pause();
        } else {
          video.play().catch(update);
        }

        video.addEventListener('play', update);
        video.addEventListener('pause', update);
        toggle.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(update);
          } else {
            video.pause();
          }
        });
        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
